import { Chip, Section } from '@patchbay/ui'
import { useQuery } from '@tanstack/react-query'
import { customerSatisfactionQuery } from './api'

export function CustomerSatisfaction({ customerId }: { customerId: string }) {
  const query = useQuery(customerSatisfactionQuery(customerId))
  if (query.isPending) return <p className="text-sm text-muted-foreground">Loading satisfaction…</p>
  if (query.isError) return <p className="text-sm text-warning">Satisfaction is unreachable; no rating summary is inferred.</p>
  const { summary, rows } = query.data
  return (
    <Section title="Satisfaction" count={summary.responses}>
      <div className="mb-2 flex flex-wrap gap-2 text-sm">
        <span>{summary.average_score == null ? 'No rating sample' : `${summary.average_score.toFixed(2)} / 3 average`}</span>
        <span>
          {summary.response_rate_pct == null ? 'Response rate unavailable' : `${summary.response_rate_pct.toFixed(1)}% response rate`}
        </span>
        <Chip tone="success">Good {summary.good}</Chip>
        <Chip tone="warning">OK {summary.ok}</Chip>
        <Chip tone="danger">Bad {summary.bad}</Chip>
      </div>
      {rows.length ? (
        <ul className="divide-y divide-border text-sm">
          {rows.slice(0, 5).map((row) => (
            <li key={row.case_id} className="py-1.5">
              <span className="font-medium">{row.case_number}</span> · {row.rating.toUpperCase()}
              {row.comment ? <span className="ml-1 text-muted-foreground">“{row.comment}”</span> : null}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-muted-foreground">Nothing matched for this customer.</p>
      )}
    </Section>
  )
}
